import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getStatic } from '../reducers';
import SectionHeader from '../components/SectionHeader';

class About extends Component {
  componentDidMount() {
    this.fetchData();
    document.querySelector('.main-wrapper').classList.add('on-full');
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }
  fetchData() {
    const { fetchPage, pageId } = this.props;
    fetchPage(pageId);
  }
  render() {
    const { about, lang } = this.props;
    const { body } = about;
    const FormattedHtml = () => ({ __html: body });
    return (
      <div className="fold fold--about fold--deco fold--main fold--main--full">
        <div className="fold--main__inner">
          <section className="fold__col fold__col--main">
            <SectionHeader lang={lang} title="about" />
            <div className="fold__col__body">
              <div className="field-body" dangerouslySetInnerHTML={FormattedHtml()} />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

About.propTypes = {
  lang: PropTypes.string.isRequired,
  about: PropTypes.shape({
    body: PropTypes.string,
  }).isRequired,
  fetchPage: PropTypes.func.isRequired,
  pageId: PropTypes.string.isRequired,
};

About.defaultProps = {
  lang: undefined,
};

const mapStateToProps = (state, { route, lang }) => {
  const regex = lang === 'ar' ?
  /(\/:lang\/)/ : /\//;
  const pageId = route.path.replace(regex, '');
  return {
    about: getStatic(state, pageId),
    pageId,
  };
};

About = connect( //eslint-disable-line
  mapStateToProps,
  actions,
)(About);

export default About;



// WEBPACK FOOTER //
// ./js/containers/About.js